import { useCallback } from 'react'
import { graphql, useMutation } from 'react-relay'

import {
  type useClearUserPushTokensMutation as UseClearUserPushTokensMutation,
  type useClearUserPushTokensMutation$data
} from '@/__generated__/useClearUserPushTokensMutation.graphql'

type CommitAsyncFn = () => Promise<useClearUserPushTokensMutation$data>

export const useClearUserPushTokensMutation = (): [CommitAsyncFn, boolean] => {
  const [commit, isPending] = useMutation<UseClearUserPushTokensMutation>(graphql`
    mutation useClearUserPushTokensMutation($input: ClearUserPushTokensInput!) {
      clearUserPushTokens(input: $input) {
        user {
          isPushNotificationsEnabled
          updatedAt
        }
      }
    }
  `)

  const commitAsync = useCallback<CommitAsyncFn>(
    () =>
      new Promise<useClearUserPushTokensMutation$data>((resolve, reject) =>
        commit({
          onCompleted: (response, errors) => {
            if (errors) {
              reject(errors)
            } else {
              resolve(response)
            }
          },
          // transport-level failures (offline, 5xx, WS drop) invoke onError, not onCompleted — without
          // this the promise would never settle and isEnablingNotifications would stay stuck on.
          onError: (error) => reject(error),
          variables: {
            input: {
              clientMutationId: 'clearUserPushTokens'
            }
          }
        })
      ),
    [commit]
  )

  return [commitAsync, isPending]
}
